//import firebaseApp from "../firebaseConfig";
import { IonListHeader } from "@ionic/react";
import {
  doc,
  collection,
  addDoc,
  getDoc,
  getFirestore,
  setDoc,
  getDocs,
  query,
  onSnapshot,
  deleteDoc,
} from "firebase/firestore";

import { getCurrentUser } from "../auth";
import * as actions from "./actions";

const db = getFirestore();

export const addUser = async (payload: any, credentials: any) => {
  let email = credentials.uname;
  let password = credentials.password;
  if (payload.role === "participant") {
    email = credentials.uname + "@waioratamariki.org.nz";
  }
  //console.log(password, email);

  return createUserDoc({ email, password }, payload);
};

/**
 * Set the logged in user in store
 * @param payload Object containing user details
 * @returns
 */
export const setUser = (payload: any) => {
  return (dispatch: any) => {
    getUser(payload.uid).then((user) => {
      if (user) {
        dispatch(
          actions.setCurrentUser({
            ...user.data(),
            emailVerified: payload.emailVerified,
            isAnonymous: payload.isAnonymous,
            uid: payload.uid,
          })
        );
      }
    });
  };
};

export const setCurrentView = (id: any) => {
  return (dispatch: any) => {
    dispatch(actions.setCurrentView(id));
  };
};

export const checkLoggedIn = () => {
  return (dispatch: any) => {
    getCurrentUser().then((user) => {
      if (user) {
        dispatch(actions.setLoggedIn(true));
      } else {
        dispatch(actions.setLoggedIn(false));
      }
    });
  };
};

export const logoutUser = () => {
  return (dispatch: any) => {
    dispatch(actions.logUserOut());
  };
};

export const loginUserUpdate = (user: any) => {
  setDoc(
    doc(db, "users", user.uid),
    {
      lastLoginAt: user.metadata.lastLoginAt,
      lastSignInTime: user.metadata.lastSignInTime,
    },
    { merge: true }
  );
};

export const getUser = async (uid: any) => {
  const docRef = doc(db, "users", uid);
  return await getDoc(docRef);
};

export const storeUserInfo = (uid: any) => {
  return (dispatch: any) => {
    const docRef = doc(db, "users", uid);
    getDoc(docRef).then((doc: any) => {
      const data: any = {};
      data[doc.id] = { ...doc.data(), id: doc.id };

      console.log(data);
      dispatch(actions.getUsersSuccess(data));
    });
  };
};

export const monitorUser = (uid: any) => {
  // return (dispatch: any) => {
  // 	db.collection("users")
  // 		.doc(uid)
  // 		.onSnapshot((doc) => {
  // 			if (doc.exists) {
  // 				dispatch(actions.monitorUserSuccess({ ...doc.data(), uid: doc.id }));
  // 				return { ...doc.data(), uid: doc.id };
  // 			}
  // 		});
  // };
};

export const addUserDoc = (user: any, payload: any) => {
  // Called when new user logins in.
  const { email, displayName, metadata } = user;
  const { initials } = payload;

  // console.log(user);
  setDoc(
    doc(db, "users", user.uid),
    {
      email: email,
      displayName: displayName ? displayName : initials ? initials : "",
      createdAt: user.createdAt
        ? user.createdAt
        : metadata
        ? metadata.createdAt
        : "",
      lastLoginAt: user.lastLoginAt
        ? user.lastLoginAt
        : metadata
        ? metadata.lastLoginAt
        : "",
      lastSignInTime: user.lastSignInTime
        ? user.lastSignInTime
        : metadata
        ? metadata.lastSignInTime
        : "",
      isAdmin: payload.role === "admin" ? true : false,
      ...payload,
    },
    { merge: true }
  );

  return (dispatch: any) => {
    dispatch(actions.addUser(payload));
  };
  // }
};

export const createUserDoc = async (credentials: any, payload: any) => {
  // Called when new user logins in.
  const { displayName, username } = payload;

  return addDoc(collection(db, "users"), {
    ...payload,
    email: credentials.email,
    password: credentials.password,
    displayName: displayName ? displayName : username ? username : "",
    isAdmin: payload.role === "admin" ? true : false,
  });
};

export const updateUser = (user: any, payload: any) => {
  // Called when new user logins in.
  // console.log(user);
  // console.log(payload.dates);
  const { email, displayName } = user;
  const { initials } = payload;

  // console.log(user);
  setDoc(
    doc(db, "users", user.uid),
    {
      email: email,
      displayName: displayName ? displayName : initials,
      isAdmin: payload.role === "admin" ? true : false,
      ...payload,
    },
    { merge: true }
  );

  return (dispatch: any) => {
    dispatch(actions.updateUser(payload));
  };
  // }
};

export const getUsers = () => {
  return (dispatch: any) => {
    const q = query(collection(db, "users"));
    onSnapshot(q, (snap: any) => {
      const data: any = {};
      snap.forEach(
        (doc: any) => (data[doc.id] = { ...doc.data(), id: doc.id })
      );
      dispatch(actions.getUsersSuccess(data));
    });
  };
};

export const setAdminUser = async (uid: string, isAdmin: boolean) => {
  setDoc(doc(db, "users", uid), { isAdmin: isAdmin }, { merge: true });
  return true;
};

// export const deleteUser = async (id: any) => {
// 	return deleteDoc(doc(db, "users", id))
// 		.then(() => {
// 			return true;
// 			//deleteUserAccount(id);
// 		})
// 		.catch((error) => {
// 			return false;
// 		});
// };

export const changeUserPassword = async (user: any, password: any) => {
  return setDoc(doc(db, "users", user), { password: password }, { merge: true })
    .then(() => {
      //console.log("changing password");
      return true;
      // Update successful.
    })
    .catch((error) => {
      console.log(error);
      // An error ocurred
      // ...
    });
};

/**
 * Get all notifications for the logged in customer
 */
export const getUserNotifications = (uid: string) => {
  // return (dispatch: any) => {
  // 	const notifications: any = {};
  // 	db.collection("users")
  // 		.doc(uid)
  // 		.collection("notifications")
  // 		.onSnapshot((snapshot) => {
  // 			snapshot.forEach(function (doc: any) {
  // 				notifications[doc.id] = { ...doc.data(), id: doc.id };
  // 			});
  // 			dispatch(actions.getUserNotificationsSuccess(notifications));
  // 		});
  // };
};

export const addUserNotifications = (nid: string, payload: any) => {
  // db.collection("users")
  // 	.get()
  // 	.then((res) => {
  // 		res.forEach((user: any) => {
  // 			if (payload.recip.includes(user.id) || payload.recip.length === 0) {
  // 				addUserNotification(user.id, nid);
  // 			}
  // 		});
  // 	});
};

export const addUserNotification = (uid: string, nid: string) => {
  // return (dispatch: any) => {
  //const notifications: any = {};
  // db.collection("users")
  // 	.doc(uid)
  // 	.collection("notifications")
  // 	.doc(nid)
  // 	.set({ read: false });
};

export const removeUserNotification = (uid: string, nid: string) => {
  // //return (dispatch: any) => {
  // db.collection("users").doc(uid).collection("notifications").doc(nid).delete();
  // // 	dispatch(actions.getUserNotificationsSuccess(notifications));
  // // });
};

export const setUserNotificationStatus = (
  uid: any,
  nid: any,
  status: boolean
) => {
  // db.collection("users")
  // 	.doc(uid)
  // 	.collection("notifications")
  // 	.doc(nid)
  // 	.update({ read: status });
};

export const updateUserDetails = (id: any, userDetails: any) => {
  // const { fname, lname, email, phoneNumber, seat } = userDetails;
  // return db
  // 	.collection("users")
  // 	.doc(id)
  // 	.update({ fname, lname, email, phoneNumber, seat })
  // 	.then((res: any) => {
  // 		return true;
  // 	})
  // 	.catch((error) => {
  // 		console.error(error);
  // 		throw error;
  // 	});
};

export const getEntries = (id: any) => {
  return getDocs(collection(db, "users", id, "entries"))
    .then((docs) => {
      let data: any = [];
      docs.forEach(
        (doc: any) => (data[doc.id] = { ...doc.data(), id: doc.id })
      );
      return data;
    })
    .catch((error) => {
      console.error(error.message);
    });

  // const querySnapshot = getDocs(
  // 	collection(document, "entries")
  // );

  // querySnapshot.forEach((doc) => {
  // 	console.log(doc.id);
  // });
};

export const getEntry = (id: any, eid: any) => {
  return getDoc(doc(db, "users", id, "entries", eid)).then((doc) => {
    return doc.data();
  });
};

export const saveEntry = (id: any, entry: any) => {
  return setDoc(doc(db, "users", id, "entries", entry.eid), entry);
};
